import { createLogger } from 'redux-logger'

export const loggerMiddleware = createLogger({
  collapsed: true,
  stateTransformer: () => {}, // Function to transform the state if it is in some "unreadable" format (immutable). By default we don't use any transformation.
})
